module.exports = __webpack_public_path__ + "static/media/location-rojo_old.a58b101e.svg";